module.exports = __webpack_public_path__ + "img/stepper-3.338d4e2d.png";